const state = {
  importExDataList: null,
  importDataCondition: null,
  importExDataArr: [],
  importExDataListPrint: null,
  dataCountImport: null,
  duplicateList: [],
  masterSelection: null,
  listBillingInfo: null,
  listImportErrorUps: null
};
const getters = {
  importExDataList: state => state.importExDataList,
  importExDataListPrint: state => state.importExDataListPrint,
  importDataCondition: state => state.importDataCondition,
  importExDataArr: state => state.importExDataArr,
  dataCountImport: state => state.dataCountImport,
  duplicateList: state => state.duplicateList,
  masterSelection: state => state.masterSelection,
  listBillingInfo: state => state.listBillingInfo,
  listImportErrorUps: state => state.listImportErrorUps
};
const mutations = {
  saveImportExDataList(state, importExData) {
    if (!importExData) {
      return;
    }
    if (importExData.importExDataList) {
      state.importExDataList = importExData.importExDataList;
    }
    if (importExData.importDataCondition) {
      state.importDataCondition = importExData.importDataCondition;
    }
    if (importExData.importExDataArr) {
      state.importExDataArr = importExData.importExDataArr;
    }
    if (importExData.duplicateList) {
      state.duplicateList = importExData.duplicateList;
    }
    if (importExData.masterSelection) {
      state.masterSelection = importExData.masterSelection;
    }
    state.importExDataListPrint = importExData.importExDataListPrint;
  },
  saveDataInit(state, dataInit) {
    if (!dataInit) {
      return;
    }
    state.dataCountImport = dataInit.dataCount;
    state.listBillingInfo = dataInit.listBillingInfo;
  },
  saveImportListErrorUps(state, listErrorUps) {
    state.listImportErrorUps = listErrorUps;
  },
  clearImportIssueList(state, deleteImportDataList) {
    if (deleteImportDataList) {
      state.importExDataList = null;
      state.importDataCondition = null;
      state.importExDataArr = null;
      state.dataCount = null;
      state.duplicateList = [];
      state.masterSelection = null;
      state.masterSelection = null;
      state.listBillingInfo = null;
    }
    state.importExDataListPrint = null;
    state.listImportErrorUps = null;
  }
};
export default {
  state,
  getters,
  mutations
};
